import { BASEAPI } from 'src/api/api';

const request = async (method, url, data, params) => {
  try {
    const response = await BASEAPI({ method, url, data, params });
    return response.data?.result;
  } catch (error) {
    const rawMessage = error?.response?.data?.error_message
      || error?.response?.data?.detail
      || error?.message
      || 'Unable to complete the request.';
    const message = typeof rawMessage === 'string'
      ? rawMessage
      : Object.values(rawMessage || {}).flat().join(' ');
    throw new Error(message);
  }
};

const base = 'tyre-management/v2';

export const tyreManagementApi = {
  getOverview: () => request('GET', `${base}/overview/`),
  getConfiguration: () => request('GET', `${base}/configuration/`),
  getVehicles: (params = {}) => request('GET', `${base}/vehicles/`, null, params),
  getVehicleLayout: (vehicleId) => request('GET', `${base}/vehicles/${vehicleId}/layout/`),
  configureVehicle: (data) => request('POST', `${base}/vehicles/configure/`, data),
  getLayouts: (params = {}) => request('GET', `${base}/layouts/`, null, params),
  getTyres: (params = {}) => request('GET', `${base}/tyres/`, null, params),
  getTyre: (id) => request('GET', `${base}/tyres/${id}/`),
  getTyreByToken: (token) => request('GET', `${base}/lookup/${token}/`),
  getTyreHistory: (id) => request('GET', `${base}/tyres/${id}/history/`),
  getTyreAttachments: (id) => request('GET', `${base}/tyres/${id}/attachments/`),
  uploadTyreAttachment: (id, data) => request('POST', `${base}/tyres/${id}/attachments/`, data),
  downloadTyreAttachment: (id, attachmentId) => BASEAPI.get(
    `${base}/tyres/${id}/attachments/${attachmentId}/download/`,
    { responseType: 'blob' }
  ),
  createTyre: (data) => request('POST', `${base}/tyres/`, data),
  bulkCreateTyres: (data) => request('POST', `${base}/tyres/bulk-create/`, data),
  extractPurchaseInvoice: (data) => request('POST', `${base}/tyres/extract-invoice/`, data),
  assignTyre: (data) => request('POST', `${base}/operations/assign/`, data),
  removeTyre: (data) => request('POST', `${base}/operations/remove/`, data),
  replaceTyre: (data) => request('POST', `${base}/operations/replace/`, data),
  transferTyre: (data) => request('POST', `${base}/operations/transfer/`, data),
  getRetreading: (params = {}) => request('GET', `${base}/retreading/`, null, params),
  sendForRetreading: (data) => request('POST', `${base}/retreading/send/`, data),
  completeRetreading: (data) => request('POST', `${base}/retreading/complete/`, data),
  getCosts: (params = {}) => request('GET', `${base}/costs/`, null, params),
  getReport: (params = {}) => request('GET', `${base}/reports/`, null, params),
  exportReport: (format, params = {}) => BASEAPI.get(`${base}/reports/`, { params: { ...params, export: format }, responseType: 'blob' }),
  createReportJob: (params = {}) => request('POST', `${base}/reports/jobs/`, params),
  getReportJobs: () => request('GET', `${base}/reports/jobs/`),
  getReportJob: (id) => request('GET', `${base}/reports/jobs/${id}/`),
  getReportJobResult: (id) => request('GET', `${base}/reports/jobs/${id}/result/`),
  exportReportJob: (id, format, section) => BASEAPI.get(`${base}/reports/jobs/${id}/export/`, {
    params: { export: format, section }, responseType: 'blob'
  }),
  getSites: () => request('GET', 'site-list/'),
};

export const unwrapList = (payload) => payload?.results || payload || [];
